import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Alert, Spinner, Fade } from 'reactstrap';
import api from '../../services/client/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight, faAddressCard } from '@fortawesome/free-solid-svg-icons';
import { Container, Title,  InputAuth, Form, LoginLink, RegisterLink, ButtonFind, LinksContainer,  LogoImage, SpanText, AlertLink } from './styles';
import useBlockedIP from '../../utils/useBlockedIP.js';
import logo from '../../assets/LogoPos2.png';
import RecoveryAcess from '../../components/RecoveryAcess/index.jsx';
import { isCpfValid } from '../../utils/cpfValidate.js';

function ForgotPassView() { 
    const [cpf, setCpf] = useState('');
    const [accountInfo, setAccountInfo] = useState(null);
    const [error, setError] = useState('');
    const [preconditionError, setPreconditionError] = useState('');
    const [inProgress, setInProgress] = useState(false);
    const [timer, setTimer] = useState(0);
    const history = useHistory();
    const [isBlocked, setIsBlocked] = useState(false); // Estado para controle de bloqueio
    const [, setLoginAttempts] = useState(0); // 
    const [showRecoveryAcess, setShowRecoveryAcess] = useState(false);
    const [tel, setTel] = useState('');
    const [mail, setMail] = useState('');
    const [username, setUsername] = useState('');
    useBlockedIP(); // Verifica o IP bloqueado
    const [shouldHideButton, setShouldHideButton] = useState(true);
    const [id, setId] = useState('')
    const [showAlert, setShowAlert] = useState(false);
      const siteUrl = "https://www.cedap.com.br/duvidas"; // URL do site que será aberto

  const handleClick = () => {
    window.open(siteUrl, "_blank"); // Abre o site em uma nova aba
  };


useEffect(() => {
  if (error || preconditionError) {
    setShowAlert(true); // mostra com fade

    const timeout = setTimeout(() => {
      setShowAlert(false); // começa a esconder com fade
      // depois que sumir, limpa o conteúdo
      setTimeout(() => setError(''), 300); // tempo igual ao da animação
      setTimeout(() => setPreconditionError(''), 300);
    }, 5000);

    return () => clearTimeout(timeout);
  }
}, [error, preconditionError]);

  
const findUser = async () => {
  if (isBlocked) {
    history.replace('/blocked-page');
    return;
  }

  if (!isCpfValid(cpf)) {
    setError('CPF inválido.');
    setInProgress(false);
    return;
  }

  if (cpf.length < 8) {
    setError('O nome de usuário deve ter pelo menos 8 caracteres.');
    return;
  }

  setInProgress(true);
  setError('');

  try {
    const response = await api().userPatient().getUserByCpf(cpf.replace(/\D/g, ''));
    const statusCode = response.status || 200;
    const returnData = response.output;

    if (!returnData || !Array.isArray(returnData) || !returnData[0]) {
      throw new Error('Dados de usuário ausentes.');
    }

    const user = returnData[0];

    if (statusCode === 428) {

      setPreconditionError('Bem-vindo! Identificamos que este é seu primeiro acesso. Faça login para continuar.');


      return;
    }

    if (!user.email || !user.id_user || !user.tel || !user.username) {
      setError('Usuário incompleto ou inválido.');
      setAccountInfo(null);
      return;
    }

    // Tudo certo — atualiza os dados do usuário
    setId(user.id_user);
    setUsername(user.username);
    setMail(user.email);
    setTel(user.tel);
    setShowRecoveryAcess(true);
    setAccountInfo(user);

  } catch (error) {
   
    setError('Usuário não encontrado.');


  } finally {
    setInProgress(false);
  }
};

    const handleCloseRecoveryAcess = () => {
      setShowRecoveryAcess(false);

      history.replace({
        pathname: '/replace-pass',
        state: {
          username: username,
          id: id,
        },
      });
    }
    
    
    useEffect(() => {
      let interval;
      if (timer > 0) {
        interval = setInterval(() => {
          setTimer(prevTimer => {
            if (prevTimer <= 1) {
              clearInterval(interval); // Limpa o intervalo
              localStorage.removeItem('blockTime'); // Limpa o tempo de bloqueio
              setIsBlocked(false); // Reinicia o bloqueio
              setLoginAttempts(0)
              localStorage.clear()
              return 0;
            }
            return prevTimer - 1;
          });
        }, 1000);
      }
      return () => clearInterval(interval);
    }, [timer]);
  
  
    const handleCpfChange = (e) => {
      const rawCpf = e.target.value.replace(/\D/g, '');
      setCpf(rawCpf);
    
      setShouldHideButton(rawCpf.length < 11); // habilita se tiver 11 ou mais dígitos
    };
    
  


    
    const applyCpfMask = (value) => {
      const cleanedValue = value.replace(/\D/g, '');
      const match = cleanedValue.match(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})$/);
      if (match) {
        return `${match[1]}${match[2] ? '.' + match[2] : ''}${match[3] ? '.' + match[3] : ''}${match[4] ? '-' + match[4] : ''}`;
      }
  
      return value;
    };

  

  
 /* outras partes do codigo */
    return (
        <Container>
            <Title><center>Recuperação de Acesso</center></Title>
            <Form>
                {!accountInfo && (
                    <>
                    <SpanText>Digite seu CPF</SpanText>
                    <InputAuth
                      type="text"
                      placeholder="Digite seu CPF"
                      value={applyCpfMask(cpf)}
                      maxLength="14"
                      onChange={handleCpfChange}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' && !shouldHideButton) {
                          findUser();
                        }
                      }}
                    />
                    {/*  outras partes do codigo  */}

                        {!shouldHideButton && (
                        <ButtonFind
                            color="primary"
                            onClick={findUser}
                           
                        >
                            {inProgress ? <Spinner size="sm" /> : 'Avançar'}
                            <FontAwesomeIcon icon={faArrowRight} style={{ marginLeft: '12px' }} />
                        </ButtonFind>
                        )}
                    </>
                )}

                {inProgress && <Spinner color="primary" />}
                <Fade in={showAlert} timeout={400}>
                {error && <Alert color="danger" >{error}</Alert>}
                {preconditionError && <Alert color="info" >{preconditionError} <AlertLink
                    onClick={() => {
                        setInProgress(true);
                        history.push({ pathname: '/login' });
                    }}
                >
                  Fazer Login.
                </AlertLink> </Alert>}

                 </Fade>
                {showRecoveryAcess && (
        
                <RecoveryAcess 
                onClose={handleCloseRecoveryAcess}
                tel={tel}
                mail={mail}
                username={username}
                />
        
                )}
              
            </Form>
           

            <button onClick={handleClick} style={{ border: "none", background: "none", cursor: "pointer", color: "#007bff" }}>
                  Está com problemas para acessar? Clique aqui.
            </button>
            <LinksContainer>
             <RegisterLink
                    onClick={() => {
                        setInProgress(true);
                        history.push({ pathname: '/cpf-user-check' });
                    }}
                >
                    <FontAwesomeIcon icon={faAddressCard} /> Fazer cadastro
                </RegisterLink>
                <LoginLink onClick={() => history.push({ pathname: '/login' })}>
                    <FontAwesomeIcon icon={faArrowLeft} /> voltar
                </LoginLink>
               
            </LinksContainer>
            <LogoImage src={logo} alt="Logo CEDAP" />
  
        </Container>
    );
}

export default ForgotPassView;
